import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import PropTypes from "prop-types";

import "./styles.scss";
import Wrapper from "../Chat/Layout/Wrapper/Wrapper";
import Back from "../../assets/icons/backBis.svg";
import Accept from "../../assets/icons/accept.svg";
import Refuse from "../../assets/icons/refuse.svg";
import {getUploadUrl} from "../../utils/baseUrl";

const Pap = ({cas, setShowAcceptPapModal, setShowRejectPapModal, contact}) => {
    const history = useHistory();
    const handleGoBack = () => {
        // Redirection dans le chat du cas
        history.push(`/case/${cas.id}`);
    };

    const handleAcception = () => {
        // Redirection dans le chat du cas
        history.push(`/case/${cas.id}`);
        setShowAcceptPapModal(true);
    };

    const handleRejection = () => {
        // Redirection dans le chat du cas
        history.push(`/case/${cas.id}`);
        setShowRejectPapModal(true);
    };

    const [selectedItem, setSelectedItem] = useState();

    const itemList = [
        {"title": "Contexte", "hash": "contexte"},
        {"title": "Votre proche", "hash": "votreproche"},
        {"title": "Notre proposition", "hash": "proposition"},
        {"title": "Rencontrez vos prestataires", "hash": "prestataires"},
        {"title": "Prev&Care vous accompagne", "hash": "accompagne"},
        {"title": "Contact", "hash": "contact"},
    ];

    return (
        <Wrapper>
            {cas &&
                <div className="pap">
                    <div id="colonneNavigation">
                        <button className="goBackPap" onClick={handleGoBack}><img src={Back}/> Retour</button>
                        <h1>Plan d&apos;aide personnalisé</h1>
                        <h2>pour {contact.prenom} {contact.nom}</h2>
                        <ul>
                            {itemList.map((item, index) => (
                                // Sidebar de gauche avec des liens d'ancrage vers les différentes sections
                                <li className={index === selectedItem ? "active" : ""} key={index}
                                    onClick={() => setSelectedItem(index)}>
                                    <a
                                        className={index === selectedItem ? "activeText" : ""}
                                        href={`${process.env.REACT_APP_UPLOAD_DIR}/pap/pap.php?id=${cas.id}#${item.hash}`}
                                        target="papiframe"
                                    >
                                        {item.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div id="content-pap">
                        {/*Génération de la page récapitulant le PAP via un iFrame*/}
                        <iframe src={`${getUploadUrl()}/pap/pap.php?id=${cas.id}`} id="papiframe"
                                name="papiframe"></iframe>
                        <div id="barreInteraction">
                            {cas.state == 4 &&
                                <div>Acceptez-vous ce plan d&apos;aide personnalisé ?</div>
                            }
                            {cas.state == 4 &&
                                <div className="proposition">
                                    <>
                                        <button onClick={handleAcception} className="accept"><img
                                            src={Accept}/> Oui,&nbsp;j&apos;accepte
                                        </button>
                                        <button onClick={handleRejection} className="refuse"><img
                                            src={Refuse}/> Non,&nbsp;je&nbsp;refuse
                                        </button>
                                    </>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </Wrapper>
    );
};

Pap.propTypes = {
    cas: PropTypes.object,
    contact: PropTypes.object,
    setShowAcceptPapModal: PropTypes.func,
    setShowRejectPapModal: PropTypes.func,
};

export default Pap;
